import React from "react";
import './privacypolicystyle.css';

function MPSKITermsConditions() {

    return (
        <div style={{ marginLeft: 10, marginRight: 10, }}>
            <h1 style={{ textAlign: 'center' }}><strong> Terms &amp; Conditions</strong></h1>

            <ol>
                <li>The MPAiSA Kiribati Wallet App ("App") is available via a mobile application to mobile customers (&ldquo;You&rdquo;). Vodafone Kiribati Limited (&ldquo;Vodafone Kiribati&rdquo;) grants You non-exclusive, non-transferable licence to use the App on one device that You own or control for personal non-commercial use only.</li>
            </ol>

            <ol start="2">
                <li>By downloading or using the App, these terms will automatically apply to You. Please read them carefully before using the App. Vodafone Kiribati is offering this App to use for your own personal use, but You should be aware that You cannot send it on to anyone else, and you&rsquo;re not allowed to copy, or modify the App, any part of the App, or our trademarks in any way.</li>
            </ol>

            <ol start="3">
                <li>You&rsquo;re not allowed to attempt to extract the source code of the App and You also should not try to translate the App into other languages or make derivative versions. The App itself, and all the trademarks, copyright, database rights and other intellectual property rights related to it, belong to Vodafone Kiribati.</li>
            </ol>

            <ol start="4">
                <li>Vodafone Kiribati is committed to ensuring that the App is as useful and efficient as possible. For that reason, Vodafone Kiribati reserves the right to make changes to the App or to charge for its services, at any time and for any reason. Vodafone Kiribati will never charge You for the App or its services without making it clear exactly what You are paying for.</li>
            </ol>

            <ol start="5">
                <li>Vodafone Kiribati cannot take responsibility for the App not working at full functionality if You don&rsquo;t have access to Wi-Fi or Vodafone Kiribati 3G/4G and/or You don&rsquo;t have any of your data balance left.</li>
            </ol>

            <ol start="6">
                <li>You are responsible for keeping any App password and log in details secure. Do not share these details and keep them safe. It is your responsibility to ensure that your device is secure and not accessible to others. Vodafone Kiribati is not responsible for any losses or charges incurred by You as a result of your failure to keep your device secure.</li>
            </ol>

            <ol start="7">
                <li>The App is provided to You &ldquo;as is&rdquo;, without support or maintenance. Neither Vodafone Kiribati nor our licensors warrant that the App will meet your requirements or that the operation of the App will be uninterrupted or error free. To the extent permitted by law, we, and our licensors, disclaim and exclude all warranties, representations, conditions and other terms of any kind, express or implied.</li>
            </ol>

            <ol start="8">
                <li>At some point Vodafone Kiribati may wish to update the App. The App is currently available on Android and iOS &ndash; the requirements for both systems (and for any additional systems we decide to extend the availability of the App to) may change, and you&rsquo;ll need to download the updates if You want to keep using the App.</li>
            </ol>

            <ol start="9">
                <li>If You disconnect your Vodafone Kiribati account or are in breach of your terms of service with Vodafone Kiribati, your App service will be terminated.</li>
            </ol>

            <ol start="10">
                <li>Vodafone Kiribati may also wish to stop providing the App and may terminate use of it at any time without giving notice of termination to You. Unless Vodafone Kiribati tells You otherwise, upon any termination, (a) the rights and licenses granted to You in these terms will end; (b) You must stop using the App, and (if needed) delete it from your device.</li>
            </ol>
            <ol start="11">
                <li>Below You will be able to find a link to the Vodafone Kiribati website where we set out our Privacy Policy. Your use of the App is subject to the terms and conditions set out in our Privacy Policy.</li>
            </ol>
            <ol start="12">
                <li>
                    <p>Vodafone Kiribati can change these terms and conditions from time to time, by publishing the changed terms and conditions on our website.
                    <a href="https://www.vodafone.com.ki/About-Us/Term-and-Conditions-(MPAiSA)"> View Privacy Policy</a></p>
                </li>
            </ol>

            <ol start="13">
                <li>All Vodafone Kiribati Postpaid and Prepaid terms and conditions shall apply.</li>
            </ol>
        </div>

    )



}

export default MPSKITermsConditions;